<h2 mat-dialog-title>Delete Commission Rule</h2>
<mat-dialog-content>
    <p>Are you sure you want to delete <strong>{{ data.ruleName }}</strong>?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-raised-button color="warn" (click)="okClick()" [disabled]="isLoading">
        {{ isLoading ? 'Deleting...' : 'Delete' }}
    </button>
</mat-dialog-actions>
